export default function createTimer() {
    let startTime = Date.now()
    let initialTime = startTime;

    return {
        start() {
            startTime = Date.now()

            return startTime
        },
        elapsedTime() {
            return Date.now() - startTime
        },
        initialElapsedTime() {
            return Date.now() - initialTime
        },
        reset() {
            startTime = Date.now()
            initialTime = startTime
        }
    }
}

export function timeLogger() {
    let lastTime = Date.now();

    return function(message) {
        const now = Date.now();
        const elapsed = (now - lastTime) / 1000;

        const formatted = elapsed < 1 
            ? `${(elapsed * 10).toFixed(1)} sec`
            : `${elapsed.toFixed(1)} sec`;

        console.log(`${message} - ${formatted}`);
    }
}